import React from 'react';
import PropTypes from 'prop-types';

import TrialPreview from '../TrialPreview';
import CustomAgreementPreview from '../CustomAgreementPreview';
import SelfServicePreview from '../SelfServicePreview';

const SubscriptionPreview = ({ type, subscription, withLinks, tenantId }) => {
  if(type === 'v8') {
    return <SelfServicePreview subscriptions={subscription} withLinks={withLinks} tenantId={tenantId} isV8Plan/>;
  }
  else if (type === 'Developer' || type === 'Free') {
    return <SelfServicePreview subscriptions={subscription} withLinks={withLinks} tenantId={tenantId}/>;
  } else if (type === 'Trial') {
    return (
      <div className="trial-subscription-preview-wrapper">
        <TrialPreview subscriptions={subscription} withLinks={withLinks} />
      </div>
    );
  } else if (type === 'Custom Agreement') {
    return <CustomAgreementPreview {...subscription} />;
  }

  return null;
};

SubscriptionPreview.defaultProps = {
  withLinks: true
};

SubscriptionPreview.propTypes = {
  type: PropTypes.string,
  subscription: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  tenantId: PropTypes.string.isRequired,
  withLinks: PropTypes.bool
};

export default SubscriptionPreview;
